import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import owner from "../assets/owner3.png";
import '../css/about.css'
import { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';


function About() {

    useEffect(() => {
        Aos.init({ duration: 1000 })
    })

    return (
        <>
            <Container
                fluid
                className="gallery-header d-flex justify-content-start align-items-center"
            >
                <Row>
                    <Col data-aos="fade-up" data-aos-delay="100">
                        <h1 className="gallery-title">About Us</h1>
                    </Col>
                </Row>
            </Container>


            <Container id='AboutMain'>
                <h1>Know About Bhadade Group</h1>

                <Row>

                    <Col id='AboutSub1' sm={6}>
                        <p>
                            Welcome to Bhadade Group — your premier destination for unforgettable events.
                            At Bhadade Catering Services, we blend lush outdoor spaces with elegant indoor halls to create the perfect setting for weddings, receptions, and corporate gatherings.
                            Every event is crafted with care to make your special moments truly memorable.
                        </p>

                        <p>
                            Our venues include the ShivShankar Lawn, offering beautifully manicured greenery ideal for outdoor celebrations, and The Elegant Halls, designed with modern amenities and customizable layouts for grand indoor events.
                            Whether you prefer a natural ambiance or a sophisticated atmosphere, our spaces cater to every occasion.
                        </p>

                        <p>
                            Backed by a professional team, we provide end-to-end event planning, catering, décor, audio-visual support, and ample parking.
                            Explore our gallery to see past celebrations, and contact us today to bring your dream event to life.
                            At Bhadade Group, we don’t just host events — we create lasting memories.
                        </p>
                    </Col>

                    <Col sm={6} className='photoo'>
                        <img src={owner} alt="Third slide" id='owner' />
                    </Col>
                </Row>

            </Container>
        </>
    );
}

export default About;